export default "__VITE_ASSET__CSetgdn5__"